import axios from 'axios';
export default () => {
    let instance = axios.create({
        baseURL: window.apiUrl,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
    });
    return instance;
}